import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { DisplayTypePipe } from '@app/shared/pipes/display-type.pipe';
import { WebEnvironmentService } from '@app/shared/services/web-environment.service';
import { SharedTargetService } from '@app/target/services/shared-target.service';
import { TranslateService } from '@ngx-translate/core';
import { ResourceResult } from '@app/target/target-api.model';
import { ProviderImageInfo } from '@app/manage-providers/provider-api.model';

interface ResourceResultListItem extends ResourceResult {
  displayType?: string;
  providerImageUrl?: string;
  providerImageInfo?: ProviderImageInfo;
}

@Component({
  selector: 'dgx-target-resource-list-item',
  templateUrl: './target-resource-list-item.component.html',
  styleUrls: ['./target-resource-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetResourceListItemComponent implements OnInit {
  @Input() public item: ResourceResultListItem;

  public i18n;

  public isRestrictedContent: boolean = false;

  constructor(
    private translate: TranslateService,
    private sharedTargetService: SharedTargetService,
    private webEnvironmentService: WebEnvironmentService,
    private displayTypePipe: DisplayTypePipe
  ) {}

  public ngOnInit(): void {
    if (!this.item) {
      throw new Error('Missing resource result item');
    }

    this.i18n = this.translate.instant([
      'Core_Endorsed',
      'OrgInternalContent_RestrictedContentNote',
    ]);

    this.i18n.OrgInternalContent_RestrictedContentNote = this.translate.instant(
      'OrgInternalContent_RestrictedContentNote',
      {
        inputType: this.displayTypePipe
          .transform(this.item.referenceType)
          .toLowerCase(),
      }
    );

    if (this.item.referenceType === 'Target') {
      this.item.displayType = this.sharedTargetService.getTypeDisplayName(
        this.item.referenceSubType as any
      );
    }

    if (this.item.referenceType === 'Provider') {
      const image = this.item.image
        ? this.webEnvironmentService.getBlobUrl(this.item.image)
        : this.webEnvironmentService.getBlobUrl(
            '/content/img/app/no-logo-seal.png'
          );
      this.item.providerImageUrl = image;
    }
  }
}
